import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default class Paw {
    constructor() {
        const self = this;

        if($('.js-paw-slider').length) {
            const paw = new Swiper('.js-paw-slider', {
                autoHeight: true,
                loop: true,
                navigation: {
                    nextEl: '.js-paw__next',
                    prevEl: '.js-paw__prev',
                },
                slidesPerView: 1
            });

            $('.js-paw__nav-elem').on('click', function() {
                self.changePawOnSlideClick(paw);
            });

            $('.js-paw__paw').on('click', function() {
                self.changeSliderOnPawClick($(this), paw);
            });
        };
    };

    changeSliderOnPawClick(paw, swiper) {
        // Remove all 'is-active' classes
        $('.js-paw__paw').removeClass('is-active');

        // Add 'is-active' class to clicked paw
        paw.addClass('is-active');

        // Navigate to slide for paw
        swiper.slideToLoop(paw.data('slide'));
    };

    changePawOnSlideClick(swiper) {
        // Remove all 'is-active' classes
        $('.js-paw__paw').removeClass('is-active');

        // Add 'is-active' class to next or prev paw, as appropriate
        $(".js-paw__paw[data-slide='" + swiper.realIndex + "']").addClass('is-active');
    };
};
